<script>
  import { ignore } from "../../Common/tools";
  import QuizFormWrapperStyling from "./QuizFormWrapperStyling.svelte";
  import QuizFormTileStyling from "./QuizFormTileStyling.svelte";
  import QuizFormHeadingStyling from "./QuizFormHeadingStyling.svelte";
  import {External, M} from "../../external";

  export let widget,
    onChange = ignore,
    onRenderStep = ignore;

  let data = widget.data,
    widgetUi = widget.$widget;

  let changeLabelStyles = () => {
    External.FormFields.editLabelStyles(widget.data, widgetUi, () => {
      onChange();
    });
  };

  let changeHeadingStyles = () => {
    External.Tools.showWindow({
      isModal: false,
      title: M.HEADING_DESCRIPTION_STYLING,
      icon: External.Popup.ICON_ADD,
      width: 400,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new QuizFormHeadingStyling({
              target: popup.getContentArea(),
              props: {
                widget: widget,
                onChange: () => {
                  triggerRenderChange();
                }
              }
            })
          );
        }
      }
    });
  };

  let changeWrapperStyles = () => {
    External.Tools.showWindow({
      isModal: false,
      title: M.QUIZ_WRAPPER,
      icon: External.Popup.ICON_ADD,
      width: 400,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new QuizFormWrapperStyling({
              target: popup.getContentArea(),
              props: {
                widget: widget,
                onChange: () => {
                  triggerRenderChange();
                }
              }
            })
          );
        }
      }
    });
  };

  let changeTileStyles = () => {
    External.Tools.showWindow({
      isModal: false,
      title: M.OPTION_BOXES,
      icon: External.Popup.ICON_ADD,
      width: 400,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new QuizFormTileStyling({
              target: popup.getContentArea(),
              props: {
                widget: widget,
                onChange: () => {
                  triggerRenderChange();
                }
              }
            })
          );
        }
      }
    });
  };

  let changeButtonStyles = () => {
    External.Tools.showWindow({
      isModal: false,
      title: M.BUTTON_SETTINGS,
      width: 550,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      markup: External.ButtonStyleHelper.popupMarkup,
      action: {
        onShow: function (popup, context) {
          External.ButtonStyleHelper.editStyles(popup, context, {
            data: Object.assign({}, data.btnNext),
            changingElement: widgetUi.find(".theme-button"),
            canChangeAlign: false,
            hasFullwidth: false,
            hasPadding: false,
            hasGradient: true,
            onChange: function (btnData) {
              data.btnNext = btnData;
              triggerRenderChange();
            }
          });
        }
      }
    });
  };

  let triggerRenderChange = () => {
    onChange();
    onRenderStep();
  };
</script>

<div class="popup-widget-wrapper form-admin-style-2">
  <div class="col20 f-left">
    <div class="col20 f-left gray-section product-select-wrapper mb-5 mt-25">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">{M.HEADING_DESCRIPTION_STYLING}</h4>
        <a class="text-link blue-text" on:click={changeHeadingStyles}>{M.STYLE}</a>
      </div>
    </div>

    <div class="col20 f-left gray-section product-select-wrapper mb-5 mt-5">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">{M.LABELS_AND_FIELDS}</h4>
        <a class="text-link blue-text" on:click={changeLabelStyles}>
          {M.STYLE}
        </a>
      </div>
    </div>
    <div class="col20 f-left gray-section product-select-wrapper mb-5 mt-5">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">{M.QUIZ_WRAPPER}</h4>
        <a class="text-link blue-text" on:click={changeWrapperStyles}>
          {M.STYLE}
        </a>
      </div>
    </div>
    <div class="col20 f-left gray-section product-select-wrapper mb-5 mt-5">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">{M.OPTION_BOXES}</h4>
        <a class="text-link blue-text" on:click={changeTileStyles}>{M.STYLE}</a>
      </div>
    </div>
    <div class="col20 f-left gray-section product-select-wrapper mb-5 mt-5">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">{M.BUTTON_STYLING}</h4>
        <a class="text-link blue-text" on:click={changeButtonStyles}>
          {M.STYLE}
        </a>
      </div>
    </div>
  </div>
</div>
